import type { TContentBlockBase, TLessonBase } from '@onesource/schemas';
import { ContentBlockResourceType } from '@onesource/schemas';
import type { ReactNode } from 'react';
import type { IconType } from 'react-icons';
import { MdLink, MdOutlineAssignment, MdOutlineQuiz, MdPictureAsPdf, MdPlayCircle } from 'react-icons/md';
import { LuClipboardList, LuFileText } from 'react-icons/lu';
import { RiPaletteLine } from 'react-icons/ri';
import { SiGoogledocs } from 'react-icons/si';

export interface LessonDetailViewProps {
  lesson: TLessonBase & { contentBlocks?: TContentBlockBase[] };
  progressPercent: number;
  breadcrumbs?: ReactNode;
  onNavigateToBlock: (block: TContentBlockBase) => void;
  onNavigateToSubLesson: (subLessonId: string) => void;
}

export interface CardProps {
  block: TContentBlockBase;
  onClick: () => void;
}

export const RESOURCE_TYPE_META: Record<ContentBlockResourceType, { icon: IconType; label: string }> = {
  [ContentBlockResourceType.VIDEO]: { icon: MdPlayCircle, label: 'Video' },
  [ContentBlockResourceType.PDF]: { icon: MdPictureAsPdf, label: 'Download' },
  [ContentBlockResourceType.TEXT]: { icon: LuFileText, label: 'Document' },
  [ContentBlockResourceType.CANVA_TEMPLATE]: { icon: RiPaletteLine, label: 'Canva Template' },
  [ContentBlockResourceType.GOOGLE_DOC]: { icon: SiGoogledocs, label: 'Google Doc' },
  [ContentBlockResourceType.WORKSHEET]: { icon: LuClipboardList, label: 'Worksheet' },
  [ContentBlockResourceType.QUIZ]: { icon: MdOutlineQuiz, label: 'Quiz' },
  [ContentBlockResourceType.REDIRECT]: { icon: MdLink, label: 'Link' },
  [ContentBlockResourceType.FORM]: { icon: MdOutlineAssignment, label: 'Form' },
  [ContentBlockResourceType.EMBED]: { icon: MdOutlineAssignment, label: 'Form' },
};
